const integrations = {
  title: "Integrações",
  description: "Integre todas suas ferramentas em um só lugar",
  empty: {
    title: "Nenhuma integração encontrada",
    description: "Configure uma nova integração para começar"
  },
  new: {
    title: "Nova Integração",
    description: "Configure uma nova integração"
  },
  form: {
    name: "Nome",
    description: "Descrição",
    type: "Tipo",
    status: "Status",
    authType: "Tipo de Autenticação",
    selectAuthType: "Selecione um tipo de autenticação",
    title: {
      label: "Nome da Integração",
      placeholder: "Ex: Jira da Squad Mobile",
      required: "O nome da integração é obrigatório"
    },
    errors: {
      requiredFields: "Campos obrigatórios não preenchidos: {{fields}}",
      create: "Erro ao criar integração. Verifique os dados e tente novamente.",
      update: "Erro ao atualizar integração. Verifique os dados e tente novamente.",
      unknown: "Erro desconhecido"
    },
    defaultDescription: "Integração configurada via Prodgy"
  },
  status: {
    active: "Ativa",
    inactive: "Inativa",
    pending: "Pendente",
    failed: "Falha",
    connected: "Conectada",
    disconnected: "Desconectada",
    syncing: "Sincronizando",
    synced: "Sincronizada",
    unknown: "Desconhecido"
  },
  fields: {
    apiKey: "Chave da API",
    model: "Modelo",
    clientId: "ID do Cliente",
    clientSecret: "Chave Secreta do Cliente",
    accessToken: "Token de Acesso",
    redirectUri: "URI de Redirecionamento",
    privateToken: "Token Privado",
    gitlabUrl: "URL do GitLab",
    gitlabProjectId: "ID do Projeto GitLab",
    organization: "Organização",
    googleProjectId: "ID do Projeto Google",
    username: "Usuário",
    password: "Senha",
    scope: "Escopo",
    apiKeyPlaceholder: "Digite sua chave da API OpenRouter",
    modelPlaceholder: "Digite o nome do modelo (ex: openai/gpt-4)",
    clientIdPlaceholder: "Digite o ID do Cliente",
    clientSecretPlaceholder: "Digite a Chave Secreta do Cliente",
    accessTokenPlaceholder: "Digite o Token de Acesso",
    redirectUriPlaceholder: "Digite a URI de Redirecionamento",
    privateTokenPlaceholder: "Digite o Token Privado",
    gitlabUrlPlaceholder: "Digite a URL do GitLab",
    gitlabProjectIdPlaceholder: "Digite o ID do Projeto GitLab",
    organizationPlaceholder: "Digite o nome da Organização",
    googleProjectIdPlaceholder: "Digite o ID do Projeto Google",
    usernamePlaceholder: "Digite o usuário",
    passwordPlaceholder: "Digite a senha",
    scopePlaceholder: "Digite o escopo"
  },
  actions: {
    connect: "Conectar",
    disconnect: "Desconectar",
    save: "Salvar alterações",
    cancel: "Cancelar",
    test: "Testar conexão",
    sync: "Sincronizar",
    update: "Atualizar",
    connecting: "Conectando...",
    updating: "Atualizando...",
    remove: "Remover",
    configure: "Configurar"
  },
  messages: {
    connected: "Integração conectada com sucesso",
    disconnected: "Integração desconectada com sucesso",
    saved: "Alterações salvas com sucesso",
    error: "Erro ao processar a operação",
    authUpdated: "Configurações de autenticação atualizadas com sucesso",
    authUpdateError: "Falha ao atualizar configurações de autenticação",
    connectionTestFailed: "Teste de conexão falhou. Por favor, verifique suas credenciais e tente novamente.",
    cannotDelete: "Não é possível remover integração",
    deleteSuccess: "foi removido com sucesso!",
    deleteError: "Erro ao remover integração. Tente novamente.",
    hasDependencies: "Esta integração está sendo usada por {{dependencies}}. Remova essas dependências antes de excluir a integração."
  },
  searchPlaceholder: "Pesquise por integrações...",
  searchTools: "Pesquise por ferramentas...",
  addIntegration: "Adicionar Integração",
  add: "Adicionar",
  encrypted: "Criptografado",
  configure: "Configurar",
  lastValidated: "Última validação",
  selectTemplate: "Selecione a ferramenta que deseja integrar ao Prodgy",
  select: "Selecionar",
  sections: {
    settings: "Configurações",
    authentication: "Autenticação"
  },
  placeholders: {
    select: "Selecione...",
    enterField: "Digite {{field}}"
  },
  defaultFields: {
    integrationName: "Nome da Integração",
    integrationNamePlaceholder: "Digite um nome para esta integração",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Editar",
    editTitle: "Editar {{name}}",
    updateSettings: "Atualize as configurações e credenciais da integração",
    configureIntegration: "Configure a integração"
  },
  scope: {
    label: "Escopo",
    addTo: "Adicionar a integração a...",
    workspaceOnly: "Somente ao workspace",
    globalAll: "Toda a organização",
    sectionWorkspace: "Do Workspace",
    sectionOrganization: "De toda a organização",
    missingOrg: "Não foi possível identificar a organização atual.",
    missingWorkspace: "Selecione um workspace ou marque a integração como global.",
    permissionsLabel: "Permissões",
    productLabel: "Produto",
    organizationLabel: "Organização",
    organizationHint: "Esta integração ficará disponível para uso em todos os produtos da organização.",
    productHint: "Esta integração terá uso restrito apenas ao produto atual e substituirá a versão da organização, se houver.",
    product: "Este produto",
    general: "Global"
  },
  postInstall: {
    title: "Integração criada — próximos passos",
    subtitle: "Configure {{name}} usando os valores abaixo e siga as instruções para concluir a instalação.",
    copied: "URL copiada",
    copyFailed: "Falha ao copiar",
    copy: "Copiar",
    instructionsLabel: "Instruções de configuração",
    confirm: "Entendi",
    manifestLabel: "App Manifest",
    copyManifest: "Copiar JSON",
    downloadZip: "Baixar ZIP",
    zipBuilding: "Gerando...",
    zipFailed: "Falha ao gerar o pacote ZIP"
  },
   delete: {
    title: "Remover Integração",
    confirmMessage: "Tem certeza de que deseja remover a integração <strong>{{name}}</strong>?",
    warning: "Esta ação não pode ser desfeita. Todas as configurações e credenciais serão permanentemente perdidas.",
    removing: "Removendo...",
    confirm: "Sim, Remover"
  },
  selector: {
    noIntegrations: "Nenhuma integração",
    noToolsFound: "Nenhuma ferramenta encontrada",
    resultCount_one: "{{count}} integração",
    resultCount_other: "{{count}} integrações",
    filtered_one: "filtrada",
    filtered_other: "filtradas",
    forQuery: "para \"{{query}}\"",
    requiredNotInstalled: "A integração exigida pelo agente não está instalada",
    addNewPrompt: "Ou adicione uma nova integração...",
    addFirstPrompt: "Adicione uma integração para começar...",
    templateDescription: "Template de integração"
  }
} as const;

export default integrations;
